import type { ReferencePrice } from './index';

// Quality is separate from rarity (Arcana/Immortal/etc.). Only remove a known,
// leading quality token; bundle names, slots and gem names remain part of the key.
export const dotaQualityDefinitions = [
  { id: 'standard', name: '普通', prefix: '' },
  { id: 'inscribed', name: '铭刻', prefix: 'Inscribed ' },
  { id: 'autographed', name: '亲笔签名', prefix: 'Autographed ' },
  { id: 'exalted', name: '尊享', prefix: 'Exalted ' },
  { id: 'genuine', name: '纯正', prefix: 'Genuine ' },
  { id: 'corrupted', name: '冥灵', prefix: 'Corrupted ' },
  { id: 'auspicious', name: '吉祥', prefix: 'Auspicious ' },
  { id: 'heroic', name: '英雄传世', prefix: 'Heroic ' },
  { id: 'frozen', name: '冻人', prefix: 'Frozen ' },
  { id: 'cursed', name: '凶煞', prefix: 'Cursed ' },
  { id: 'unusual', name: '独特', prefix: 'Unusual ' },
  { id: 'elder', name: '上古', prefix: 'Elder ' },
  { id: 'infused', name: '融合', prefix: 'Infused ' },
  { id: 'favored', name: '青睐', prefix: 'Favored ' },
] as const;

export function dotaQuality(marketHashName: string) {
  const name = marketHashName.trim();
  const quality = dotaQualityDefinitions.find(value => value.prefix && name.startsWith(value.prefix) && name.length > value.prefix.length) ?? dotaQualityDefinitions[0];
  return { ...quality, baseName: name.slice(quality.prefix.length) };
}

export function dotaVariantNames(marketHashName: string) {
  const { baseName } = dotaQuality(marketHashName);
  return dotaQualityDefinitions.map(quality => quality.prefix + baseName);
}

export type DotaMarketCatalogItem = {
  id: string;
  marketHashName: string;
  name: string;
  imageUrl: string;
  type: string;
  steamUrl?: string;
  referencePrice?: ReferencePrice;
  salePriceCny?: number;
  listings?: number;
};
export type DotaCatalogDetail = DotaMarketCatalogItem & { variants: DotaMarketCatalogItem[] };
